import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';

@Injectable()
export class BackendService {
  token;
  headers;

  constructor(
    private _http: Http
  ) {}

  setToken(token) {
    this.token = token;
  }

  // set headers (can be extended with a param if needed)
  requestOptions() {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    headers.set('x-token', this.token);
    return new RequestOptions({ headers: headers });
  }

  // get constants
  getSetting(zip?) {
    return this._http.get(`/settings?zip=${zip}`).toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  // get all questions for step
  getFormData(step: string) {
    let options = this.requestOptions();
    return this._http.get(`/quote/page/${step}`, options).toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  // get all form questions
  getAllFormData() {
    let options = this.requestOptions();
    return this._http.get(`/quote/page`, options).toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  // send step data to server
  setFormData(step: string, value: any, completed?: boolean) {
    let options = this.requestOptions();
    let payload = {
      step: step,
      data: value
    };
    if (completed) {
      payload['completed'] = completed;
    }
    return this._http.post('/quote/set/data', payload, options).toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  // get fields options
  getFormOptions() {
    let options = this.requestOptions();
    return this._http.get(`/template/data`, options).toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  extractData(res: Response) {
    let body = res.json();
    return body.data || {};
  }

  handleError (error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/shared/backend.service.ts